export const SET_SUPPORT_DATA = 'support/set-support-data';
export const SET_MORE_SUPPORT_DATA = 'support/set-more-support-data';
export const RESET_SUPPORT_DATA = 'support/reset-support-data';
export const SET_CHAT_DETAIL_DATA = 'support/chat-detail-data';
export const SET_CHAT_MSG_DATA = 'support/chat-msg-data';
export const SET_CHAT_MSG_LIST_DATA = 'support/chat-msg-list-data';
export const SET_MORE_CHAT_MSG_LIST_DATA = 'support/more-chat-msg-list-data';
